<button [class]="btnClass" [disabled]="disabled" (click)="show()">Verify</button>
